var _path, _linearGradient, _path2, _path3, _defs, _mask, _g, _path4, _path5, _linearGradient2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _linearGradient3, _path16, _path17, _linearGradient4, _path18, _path19, _path20, _path21, _path22, _linearGradient5, _path23, _linearGradient6, _path24, _path25, _path26, _linearGradient7, _path27, _path28, _linearGradient8, _path29, _linearGradient9, _path30, _path31, _path32, _linearGradient10, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _circle, _defs2, _mask2, _path42, _linearGradient11, _path43, _linearGradient12, _path44;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "0 0 800 600",
    enableBackground: "new 0 0 800 600",
    id: "man-developing-website-on-desk",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M690.59 464.13h80.29c4.36-2.25 7.35-6.82 7.35-12.09 0-6.82-5.01-12.47-11.53-13.44.01-.22.02-.44.02-.67 0-7.98-6.6-14.45-14.74-14.45-.85 0-1.68.07-2.5.21-3.51-6.09-10.36-10.22-18.23-10.22-9.17 0-16.95 5.61-19.68 13.39-.86-.17-1.75-.27-2.65-.27-7.82 0-14.16 6.73-14.16 15.03 0 .93.08 1.85.23 2.73-5.92.38-10.6 4.91-10.6 10.45 0 4.07 2.52 7.59 6.2 9.33z",
    opacity: 0.1,
    fill: "#fff"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 410.635,
    x2: 410.635,
    y1: -1.336,
    y2: 600.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M745.2 339.56C745.2 154.79 595.41 5 410.63 5 225.86 5 76.07 154.79 76.07 339.56c0 105.4 48.76 199.4 124.93 260.72h419.27c76.17-61.32 124.93-155.32 124.93-260.72z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M503.67 209.55c0 2.06-.65 3.72-1.45 3.72h-82.25c-.8 0-1.45-1.67-1.45-3.72 0-2.06.65-3.72 1.45-3.72h82.25c.8 0 1.45 1.67 1.45 3.72z",
    opacity: 0.4,
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 422,
    height: 307,
    x: 200,
    y: 294,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 422,
    height: 307,
    x: 200,
    y: 294,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    mask: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M667.1 175.99c0 2.06-1.9 3.72-4.24 3.72h-240.1c-2.34 0-4.24-1.67-4.24-3.72 0-2.06 1.9-3.72 4.24-3.72h240.1c2.34 0 4.24 1.67 4.24 3.72zM583.11 191.81c0 2.06-1.26 3.72-2.81 3.72H421.32c-1.55 0-2.81-1.67-2.81-3.72 0-2.06 1.26-3.72 2.81-3.72H580.3c1.55 0 2.81 1.66 2.81 3.72z",
    opacity: 0.4,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300.72 582.47v-.86h55.07zM283.53 582.47l-47.38-.86h47.38z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 641.158,
    x2: 644.282,
    y1: 489.084,
    y2: 489.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#100060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090e96"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M643.13 507.56s-2.16-13.67-1.95-16.61c.21-2.94 1.02-18.47 1.02-18.47l2.09-1.86s-2.06 17.3-1.8 22.41c.25 5.1.64 14.53.64 14.53z",
    fill: "url(#d)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M554.68 371.79h11.58v228.24h-11.58z",
    fill: "#1289cc",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M548.99 371.79h11.58v228.24h-11.58z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M592.05 371.79h11.53v228.24h-11.53z",
    fill: "#1289cc",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M586.36 371.79h11.53v228.24h-11.53z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M309.53 371.79h11.58v228.24h-11.58z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#125cae"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M303.85 371.79h11.58v228.24h-11.58z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M346.9 371.79h11.53v228.24H346.9z",
    fill: "#1289cc",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M341.22 371.79h11.53v228.24h-11.53z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M261.49 362.32h364.45v22.61H261.49z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 407.438,
    x2: 538.178,
    y1: 318.561,
    y2: 318.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#fff"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m424.23 280.97 112.16-7.9 1.79 3.93-14.71 80.25h-5.17l-110.86 6.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#e)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M420.31 273.07h115.68L519.2 356.2H403.51z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 487.791,
    x2: 519.543,
    y1: 359.186,
    y2: 359.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#fff"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M487.79 356.05h31.75v6.26h-31.75z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#f)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M380.85 356.05h106.94v6.26H380.85z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#431ca3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m424.23 277.89-14.86 73.44h105.85l14.86-73.44z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3f2759"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M443.71 362.32c3.58.44 11.13-.7 16.5-4.17 5.32-3.48 9.54-6.78 9.54-6.78s11.59 1.51 12.33-1.14c.32-3.54-15.02-7.73-17.15-7.98-2.19-.25-20.17 2.28-22.01 4.12-1.84 1.83.79 15.95.79 15.95zM383.78 352.23c3.58.45 11.13-.69 16.45-4.17 5.32-3.48 10.39-8.55 10.39-8.55s11.58 1.09 11.33 0c-.3-1.04-14.81-7.11-17-7.35-2.14-.25-20.17 2.29-22.01 4.13-1.84 1.82.84 15.94.84 15.94z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M404.8 338.22c1.14 1.44 8.4 6.86 7.01 8.94-1.39 2.14-4.72 3.03-8.35.4s-5.91-5.72-4.92-6.76c1-1.04 6.26-2.58 6.26-2.58z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 242.597,
    x2: 394.824,
    y1: 314.881,
    y2: 314.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3113c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#2f18c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#2927cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#1f40d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#1263e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#008fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M250.31 266.61c-11.03 4.47-8.4 25.74-3.38 41 4.97 15.26 56.5 51.28 71.76 55.26 15.26 3.93 74.44-14.56 74.44-14.56 4.02-8.2.55-16.9-6.76-15.01 0 0-57.69 9.04-66.34-.94-6.96-8.01-58.04-70.47-69.72-65.75z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#g)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 260.194,
    x2: 287.175,
    y1: 196.16,
    y2: 267.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#fff"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M297.02 238.98c-18.04 36.32-55.11 24.2-63.85-10.53-8.75-34.69-11.03-64.65 19.38-69.92 33.04-5.72 62.56 44.12 44.47 80.45z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#h)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M240.57 239.78c3.43 10.78 2.38 39.7 2.38 39.7s48.8 14.21 47.31 7.65c-5.96-26.59-8.99-49.84-14.46-54.71-4.52-3.98-15.65 9.39-35.23 7.36z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M340 567.15s10.48 12.67 24.05 18.34 19.68 8.1 17.49 11.58c-2.19 3.48-19.58 1.84-32.7 2.29-13.07.45-21.91 1.44-22.36-2.73-.45-4.12 1.64-27.03 1.64-27.03l11.88-2.45z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 340.829,
    x2: 345.481,
    y1: 474.88,
    y2: 581.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#100022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090e96"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M320.92 468.56c.5 14.21 5.32 120.78 5.32 120.78 3.37 3.89 25.65-4.1 27.21-9.51 0 0 9.56-118.63 5.83-119.18-3.67-.49-38.36 7.91-38.36 7.91z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#i)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M454.5 567.65s10.49 12.67 24 18.39c13.57 5.67 19.68 8.05 17.49 11.58-2.19 3.48-19.58 1.79-32.65 2.24-13.12.45-21.96 1.44-22.41-2.68-.45-4.17 1.64-27.08 1.64-27.08l11.93-2.45z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 334.145,
    x2: 458.197,
    y1: 446.239,
    y2: 587.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#10003b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090e96"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M248.62 425.67c-1.59 11.08-18.44 28.43 2.09 45.77 20.52 17.34 152.66 2.68 154.35 5.02 1.69 2.29 34.39 114.72 34.39 114.72s28.29-.89 26.81-12.47c-10.92-30.16-9.12-126.45-31.23-136.99-22.08-10.53-186.41-16.05-186.41-16.05z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#j)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 211.814,
    x2: 337.41,
    y1: 363.16,
    y2: 363.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M302.78 269.49c-18.93-5.02-75.51-9.07-83.09 7.11-17.6 37.57-3.59 181.93 20.91 184.31 15.75 1.54 93.93-.85 96.56-29.22 3.44-37.32-31.1-91.29-34.38-162.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#k)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M218.18 387.29h19.18v95.21h-19.18z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M214.1 386.52h19.18v95.21H214.1z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 299.975,
    x2: 445.298,
    y1: 304.053,
    y2: 355.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#0090ff"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M302.78 269.49c-11.03 4.47-8.45 25.79-3.43 41.05 5.02 15.21 56.55 51.23 71.81 55.21 15.26 3.93 76.28-3.77 76.28-3.77 3.98-8.2.55-16.9-6.81-15.01 0 0-59.53-1.74-68.18-11.73-6.9-8.01-58.04-70.47-69.67-65.75z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#l)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M283.6 193.16c-3.53-4.47 6.11 14.21 3.18 22.06.05-8.4-20.32-18.54-12.47 4.27.95 2.78 2.13 14.67 2.13 14.67-.2 4.9-25.26 19.7-33.53 14-7.5-4.37-19.38-21.96-26.98-41.69-7.65-19.73 5.76-29.37 5.76-29.37s-1.84-5.02 4.22-14.46c4.72-7.45 75.09-22.21 71.31 10.28-.8 6.72-7.85 12.54-13.62 20.24z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M200.88 309.7h72.99c5.28 0 9.64 5.86 9.64 13.02v54.46c0 7.16-4.36 13.02-9.64 13.02h-72.99c-5.32 0-9.67-5.86-9.67-13.02v-54.46c0-7.16 4.35-13.02 9.67-13.02z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M193.71 309.86h72.99c5.28 0 9.64 5.86 9.64 13.02v54.46c0 7.16-4.36 13.02-9.64 13.02h-72.99c-5.32 0-9.67-5.86-9.67-13.02v-54.46c-.01-7.16 4.35-13.02 9.67-13.02zM283.53 486.65h17.19v97.05h-17.19z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M230.8 581.61h124.88v6.81H230.8z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M353.05 599.25c5.07 0 9.14-4.08 9.14-9.09 0-5.07-4.07-9.14-9.14-9.14-5.02 0-9.09 4.07-9.09 9.14-.01 5.02 4.07 9.09 9.09 9.09zM291.02 599.05c5.07 0 9.14-4.08 9.14-9.09 0-5.07-4.08-9.14-9.14-9.14-5.02 0-9.09 4.07-9.09 9.14-.01 5.01 4.07 9.09 9.09 9.09zM231.2 599.25c5.02 0 9.14-4.08 9.14-9.09 0-5.07-4.12-9.14-9.14-9.14-5.02 0-9.14 4.07-9.14 9.14 0 5.02 4.12 9.09 9.14 9.09zM211.5 471.44h161.2c6.11 0 11.08 4.97 11.08 11.03 0 6.11-4.97 11.08-11.08 11.08H211.5c-6.06 0-11.03-4.97-11.03-11.08 0-6.06 4.97-11.03 11.03-11.03z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M238.99 266.69c.25-3.18 2.5-12.13 2.5-12.13s36.57-2.49 45.27 1.59c1.36.64 9.81 13.09 9.81 13.09-23.06-4.18-42.79-4.38-57.58-2.55z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#bcd8fa"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M424.23 277.89h105.85l-.67 3.29-105.88.2zM514.68 289.33c0 .5-.4.9-.9.9h-83.69c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h83.69c.5 0 .9.4.9.9zM498.24 294.44c0 .5-.33.9-.74.9h-68.61c-.41 0-.74-.4-.74-.9s.33-.9.74-.9h68.61c.41 0 .74.41.74.9zM497.22 300.76c0 .5-.33.9-.74.9h-68.61c-.41 0-.74-.4-.74-.9s.33-.9.74-.9h68.61c.41 0 .74.4.74.9zM511.27 306.29c0 .5-.4.9-.9.9h-83.78c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h83.78c.5 0 .9.41.9.9zM508.17 319.46c0 .5-.4.9-.9.9h-83.78c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h83.78c.49 0 .9.4.9.9zM477.84 312.54c0 .5-.25.9-.56.9h-52.15c-.31 0-.56-.4-.56-.9s.25-.9.56-.9h52.15c.31 0 .56.4.56.9zM460.41 325.2c0 .5-.18.9-.4.9h-37.65c-.22 0-.4-.4-.4-.9s.18-.9.4-.9H460c.23 0 .41.4.41.9zM489.15 332.14c0 .5-.32.9-.72.9h-67.4c-.4 0-.72-.4-.72-.9s.33-.9.72-.9h67.4c.39 0 .72.4.72.9z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1e8191"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M388.94 108.43c0 .73-.59 1.32-1.32 1.32-.73 0-1.32-.59-1.32-1.32 0-.73.59-1.32 1.32-1.32.73 0 1.32.59 1.32 1.32zM483.64 190.28c0 .73-.59 1.32-1.32 1.32s-1.33-.59-1.33-1.32c0-.73.59-1.32 1.33-1.32s1.32.58 1.32 1.32zM345.28 119.07c0 .73-.59 1.32-1.32 1.32-.73 0-1.32-.59-1.32-1.32 0-.73.59-1.33 1.32-1.33.73.01 1.32.6 1.32 1.33zM238.68 117.75c0 .73-.59 1.32-1.32 1.32-.73 0-1.32-.59-1.32-1.32 0-.73.59-1.32 1.32-1.32.73-.01 1.32.59 1.32 1.32zM614.04 275.26c0 .73-.59 1.32-1.32 1.32s-1.33-.59-1.33-1.32.59-1.32 1.33-1.32 1.32.59 1.32 1.32zM618.39 187.01l1.41 2.86 3.15.45-2.28 2.23.54 3.14-2.82-1.48-2.82 1.48.53-3.14-2.28-2.23 3.16-.45zM291.7 70.98l1.76 3.57 3.94.57-2.85 2.78.67 3.93-3.52-1.86-3.53 1.86.67-3.93-2.85-2.78 3.94-.57zM686.65 245.8l1.77 3.57 3.94.57-2.85 2.78.67 3.93-3.53-1.86-3.52 1.86.67-3.93-2.85-2.78 3.94-.57z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 166.58,
    cy: 235.19,
    r: 4.67,
    fill: "#fff"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "m",
    width: 92.89,
    height: 92.89,
    x: 507.42,
    y: 56.82,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "back",
    floodColor: "white",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "n",
    width: 92.89,
    height: 92.89,
    x: 507.42,
    y: 56.82,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#m)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 212.569,
    x2: 289.79,
    y1: 309.947,
    y2: 361.592,
    gradientTransform: "scale(-1 1)rotate(44.854 128.14 -754.315)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M520.94 136.02c18.1 18.18 47.5 18.26 65.69.17 18.18-18.09 18.26-47.5.17-65.68-18.09-18.18-47.5-18.26-65.68-.17-18.19 18.09-18.27 47.5-.18 65.68z",
    mask: "url(#n)",
    fill: "url(#o)"
  })))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M520.94 136.02c18.1 18.18 47.5 18.26 65.69.17 18.18-18.09 18.26-47.5.17-65.68-18.09-18.18-47.5-18.26-65.68-.17-18.19 18.09-18.27 47.5-.18 65.68z",
    fill: "#fff"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 112.784,
    x2: 627.311,
    y1: 214.635,
    y2: 314.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#7633ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#7051ff",
    stopOpacity: 0.0882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#6685ff",
    stopOpacity: 0.2596
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5eb1ff",
    stopOpacity: 0.4279
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#57d3ff",
    stopOpacity: 0.5893
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#53ebff",
    stopOpacity: 0.7421
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#50faff",
    stopOpacity: 0.8829
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fffff"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m83.42 354.06 325.95-2.73 7.22.27 98.63-.27 14.86-73.44L133.49 73.52",
    fill: "url(#p)"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 393.064,
    x2: 519.623,
    y1: 120.397,
    y2: 120.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#acc2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#d9e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#f5f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M499.63 115.95c-3.73 0-7.22 1.02-10.2 2.8-.71-10.4-9.37-18.61-19.94-18.61-2.58 0-5.04.49-7.3 1.38-2.88-9.64-11.81-16.67-22.39-16.67-12.9 0-23.37 10.46-23.37 23.37 0 .33.01.66.03.98h-.03c-12.9 0-23.37 10.46-23.37 23.37 0 12.9 10.46 23.37 23.37 23.37.81 0 1.6-.04 2.39-.12h78.63c.72.08 1.44.12 2.18.12 11.04 0 19.99-8.95 19.99-19.99 0-11.05-8.95-20-19.99-20z",
    opacity: 0.2,
    fill: "url(#q)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.33b0c03bfbb8cf7a0bdde4dcd1b49bd2.svg";
export { ForwardRef as ReactComponent };